export { ProductCardDeleteFromWishlist } from './delete-wishlist'
